export enum CountTimes {
  amOpenCount = 'AM Open Count',
  amCloseCount = 'AM Close Count',
  pmOpenCount = 'PM Open Count',
  pmCloseCount = 'PM Close Count',
  check1 = 'Check 1',
  check2 = 'Check 2',
  startShiftCount = 'Start Shift Count',
  endShiftCount ='End Shift Count'
}
